import clsx from "clsx"

import useDateFormatters from "@hooks/useDateFormatters"

import { Table } from "@organisms"

import styles from "./DateTimeCell.module.scss"
import { DateTimeCellProps } from "./DateTimeCell.types"

export default function DateTimeCell(props: DateTimeCellProps) {
    const { value, showTime, isDangerous } = props

    const { formatDate, formatDatetime } = useDateFormatters()

    if (!value) {
        return <Table.Cells.NoValueCell />
    }

    return (
        <div
            className={clsx(styles.base, {
                [styles.dangerous]: isDangerous,
            })}
        >
            {showTime ? formatDatetime(value) : formatDate(value)}
        </div>
    )
}
